"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentField = void 0;
const joi_1 = __importDefault(require("joi"));
const field_types_1 = require("../../types/field_types");
const datasheet_1 = require("../datasheet");
const number_base_field_1 = require("./number_base_field");
const utils_1 = require("../../utils");
class PercentField extends number_base_field_1.NumberBaseField {
    constructor(field, state) {
        super(field, state);
        this.field = field;
        this.state = state;
    }
    // preview state data
    cellValueToString(cellValue, cellToStringOption) {
        if (this.validate(cellValue)) {
            const cellString = (0, utils_1.numberToShow)((0, utils_1.times)(cellValue, 100), this.field.property.precision);
            const { hideUnit } = cellToStringOption || {};
            return cellString == null ? null : `${cellString}${hideUnit ? '' : '%'}`;
        }
        return null;
    }
    // Return the default value of the field attribute configuration when adding a record
    defaultValue() {
        const { defaultValue } = this.field.property;
        return defaultValue ? (0, utils_1.str2number)(defaultValue) : null;
    }
    compareCellValue(cellValue) {
        const cellValue2Str = this.cellValueToString(cellValue, { hideUnit: true });
        return cellValue2Str === null ? null : (0, utils_1.str2number)(cellValue2Str);
    }
    compare(cellValue1, cellValue2) {
        return number_base_field_1.NumberBaseField._compare(this.compareCellValue(cellValue1), this.compareCellValue(cellValue2));
    }
    validateProperty() {
        return PercentField.propertySchema.validate(this.field.property);
    }
    static createDefault(fieldMap) {
        return {
            id: datasheet_1.DatasheetActions.getNewFieldId(fieldMap),
            type: field_types_1.FieldType.Percent,
            name: datasheet_1.DatasheetActions.getDefaultFieldName(fieldMap),
            property: this.defaultProperty(),
        };
    }
    static defaultProperty() {
        return {
            precision: 0,
        };
    }
    get openFieldProperty() {
        const { defaultValue, precision } = this.field.property;
        return {
            defaultValue,
            precision
        };
    }
    validateUpdateOpenProperty(updateProperty) {
        return PercentField.propertySchema.validate(updateProperty);
    }
}
exports.PercentField = PercentField;
PercentField.propertySchema = joi_1.default.object({
    precision: joi_1.default.number().min(0).max(10).required(),
    defaultValue: joi_1.default.string().allow('')
}).required();
//# sourceMappingURL=percent_field.js.map